<template>
  <el-main>
    <div class="mybread">
      <p><i class="el-icon-location"></i>当前位置：</p>
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item>客户项目</el-breadcrumb-item>
        <el-breadcrumb-item>发票管理</el-breadcrumb-item>
      </el-breadcrumb>
    </div>

    <div class="form">
      <el-form ref="form" label-width="100px" label-position="left">
        <el-form-item label="" style="margin-left: -100px;">
          <el-col :span="5">
            <el-select v-model="form.atype" placeholder="请选择类别" style="margin-right: 0; width: 100%;">
              <el-option label="发票代码" value="invoice_code"></el-option>
              <el-option label="发票号码" value="invoice_no"></el-option>
              <el-option label="合同编号" value="contract_no"></el-option>
              <el-option label="客户公司名称" value="client_company"></el-option>
              <el-option label="品牌" value="brand"></el-option>
              <el-option label="项目名称" value="contract_name"></el-option>
              <el-option label="开票金额" value="invoice_amount"></el-option>
            </el-select>
          </el-col>
          <el-col :span="12" style="margin-right: 10px;">
            <el-input placeholder="请输入内容" v-model="form.key" @keyup.enter.native="search" clearable @clear="search">
            </el-input>
          </el-col>
          <el-col :span="2">
            <el-button type="primary" icon="el-icon-search" @click="search">搜索</el-button>
          </el-col>
        </el-form-item>

        <el-form-item label="发票时间" prop="time">
          <el-col :span="12">
            <el-date-picker v-model="form.time" type="datetimerange" range-separator="--" start-placeholder="开始日期"
              end-placeholder="结束日期" style="margin-right: 10px;" @change="search(false)">
            </el-date-picker>
          </el-col>
        </el-form-item>

        <el-form-item label="更多" prop="type">
          <el-col :span="5" style="margin-right: 20px;">
            <el-select v-model="form.status" placeholder="发票状态" style="margin-right: 0; width: 100%;"
              @change="search(false)">
              <el-option label="正常" value="1"></el-option>
              <el-option label="作废" value="2"></el-option>
            </el-select>
          </el-col>

        </el-form-item>

        <el-form-item label="已选条件">
          <el-tag v-for="tag in tags" :key="tag.key" effect="dark" closable @close="removeTag(tag)">
            {{ tag.key }}: {{ tag.value }}
          </el-tag>
        </el-form-item>
      </el-form>
    </div>

    <div class="table">
      <div class="filterwrap">
        <div class="filter">
          <el-checkbox-group class="filtergroup" v-model="checkList" prop="checkList" :min="5">
            <el-checkbox label="发票代码"></el-checkbox>
            <el-checkbox label="发票号码"></el-checkbox>
            <el-checkbox label="合同编号"></el-checkbox>
            <el-checkbox label="客户公司名称"></el-checkbox>
            <el-checkbox label="品牌"></el-checkbox>
            <el-checkbox label="项目名称"></el-checkbox>
            <el-checkbox label="合同金额"></el-checkbox>
            <el-checkbox label="收款计划名称"></el-checkbox>
            <el-checkbox label="发票类型"></el-checkbox>
            <el-checkbox label="发票金额"></el-checkbox>
            <el-checkbox label="已收款"></el-checkbox>
            <el-checkbox label="计划收款时间"></el-checkbox>
            <el-checkbox label="发票时间"></el-checkbox>
            <el-checkbox label="收款时间"></el-checkbox>
            <el-checkbox label="发票状态"></el-checkbox>
          </el-checkbox-group>
        </div>        
        <div class="btnarea">
          <el-button @click="exportInvoiceToExcel" v-if="NodeInclude('103')">导出数据</el-button>
        </div>
      </div>

      <el-table :data="itemList" border stripe style="width: 100%;" highlight-current-row>
        <el-table-column prop="invoice_code" label="发票代码" header-align="center" align="center" min-width="150" v-if="check('发票代码')"/>
        <el-table-column prop="invoice_no" label="发票号码" header-align="center" align="center" min-width="200" v-if="check('发票号码')"/>
        <el-table-column prop="contract_no" label="合同编号" header-align="center" align="center" min-width="150" v-if="check('合同编号')">
          <template slot-scope="scope">
            <div class="linkwrap normal">
              <el-link type='primary' class="link" @click="link(`/project/detail?id=${scope.row.applyArr.project_id}`)">{{  scope.row.applyArr ? (scope.row.applyArr.projectArr.contract_no ? scope.row.applyArr.projectArr.contract_no : '待填写') : ''}}</el-link>
            </div>
          </template>           
        </el-table-column>
        <el-table-column prop="client_company" label="客户公司名称" header-align="center" align="center" min-width="200" v-if="check('客户公司名称')">
          <template slot-scope="scope">
            {{ scope.row.applyArr ? scope.row.applyArr.projectArr.client_company : ''}}
          </template>           
        </el-table-column>
        <el-table-column prop="brand" label="品牌" header-align="center" align="center" min-width="150" v-if="check('品牌')">
          <template slot-scope="scope">
            {{ scope.row.applyArr ? scope.row.applyArr.projectArr.brand : ''}}
          </template> 
        </el-table-column>
        <el-table-column prop="contract_name" label="项目名称" header-align="center" align="center" min-width="300" v-if="check('项目名称')">
          <template slot-scope="scope">
            {{ scope.row.applyArr ? scope.row.applyArr.projectArr.contract_name : ''}}
          </template> 
        </el-table-column>
        <el-table-column prop="contract_name" label="合同金额" header-align="center" align="right" min-width="100" v-if="check('合同金额')">
          <template slot-scope="scope">
            {{ scope.row.applyArr ? scope.row.applyArr.projectArr.contract_amount : ''}}
          </template> 
        </el-table-column>
        <el-table-column prop="contract_name" label="收款计划名称" header-align="center" align="center" min-width="250" v-if="check('收款计划名称')">
          <template slot-scope="scope">
            {{ scope.row.applyArr ? (scope.row.applyArr.billArr.bill_name ? scope.row.applyArr.billArr.bill_name : '待填写') : ''}}
          </template> 
        </el-table-column>
        <el-table-column prop="type" label="发票类型" header-align="center" align="center" min-width="120" v-if="check('发票类型')">
          <template slot-scope="scope">
            {{ dd.invoice_type[scope.row.applyArr.type] }}
          </template>
        </el-table-column>
        <el-table-column prop="invoice_amount" label="发票金额" header-align="center" align="right" min-width="100" v-if="check('发票金额')"/>
        <!-- <el-table-column prop="receive_amount" label="已收款" header-align="center" align="right" min-width="100" v-if="check('已收款')"/> -->
        <el-table-column prop="hope_time" label="计划收款时间" header-align="center" align="center" min-width="120" v-if="check('计划收款时间')">
          <template slot-scope="scope">
            {{  scope.row.applyArr.billArr ? (scope.row.applyArr.billArr.estimate_date != '0000-00-00' ? scope.row.applyArr.billArr.estimate_date : scope.row.applyArr.billArr.bill_date) : '暂无'}}
          </template>
        </el-table-column>
        <el-table-column prop="invoice_date" label="发票时间" header-align="center" align="center" min-width="120" v-if="check('发票时间')" />
        <!-- <el-table-column prop="receive_date" label="收款时间" header-align="center" align="center" min-width="120" v-if="check('收款时间')">
          <template slot-scope="scope">
            {{ scope.row.receive_date != '0000-00-00' ? scope.row.receive_date : '未收款'}}
          </template>
        </el-table-column> -->
        <el-table-column prop="type" label="发票状态" header-align="center" align="center" min-width="80" v-if="check('发票状态')">
          <template slot-scope="scope">
            <div class="circle-tag" :style="{'background': dd.invoice_update_c[scope.row.status].color}">
              <div class="word">{{ dd.invoice_update_c[scope.row.status].word }}</div>
            </div>
          </template> 
        </el-table-column>
        <el-table-column prop="" label="操作" header-align="center" align="center" width="50" fixed="right" v-if="NodeInclude('98')">
          <template slot-scope="scope">
            <div class="linkwrap">
              <el-link type='primary' class="link" @click="viewClick(scope.row)" v-if="NodeInclude('98')">查看</el-link>
            </div>
          </template>
        </el-table-column>
      </el-table>
      <div class="apage">
        <el-pagination @current-change="handleCurrentChange" :current-page="p" :page-size="30"
          layout="total, prev, pager, next, jumper" :total="total">
        </el-pagination>
      </div>
    </div>
  </el-main>
</template>

<script>
// CodeToText
import * as api from '@/api'
import store from '@/store'
import {thousands} from '@/utils/index.js'
export default {
  name: 'invoice',
  data() {
    return {
      nodeLimtList: [],
      checkList: [
        '发票代码',
        '发票号码',
        '合同编号',
        '客户公司名称',
        '品牌',
        '项目名称',
        '合同金额',
        '收款计划名称',
        '发票类型',
        '发票金额',
        '已收款',
        '计划收款时间',
        '发票时间',
        '收款时间',
        '发票状态',
      ],
      itemList: [],
      total: 0,
      perPage: 30,
      p: 1,
      form: {
        key: '',
        atype: 'invoice_no',
        time: ['', ''],
      },
    }
  },
  computed: {
    tags() {
      let temp = [
        {
          key: this.dd.proType[this.form.atype],
          val: 'atype',
          value: this.form.key,
          active: !!this.form.atype && !!this.form.key,
        },
        {
          key: '发票时间',
          val: 'time',
          value: this.dateValue(this.form.time),
          active: !!this.form.time && this.form.time[0] && !!this.form.time && this.form.time[1],
        },
        {
          key: '发票状态',
          val: 'status',
          value: this.dd.invoice_update[this.form.status],
          active: !!this.form.status,
        }, 
      ]
      temp = temp.filter((item) => item.active)
      return temp
    },
  },
  created() {
    this.query = this.$route.query
    this.query.invoice_no && (this.form.key = this.query.invoice_no) && store.commit('setInvoiceData', JSON.parse(JSON.stringify(this.form)))
    this.query.invoice_no && this.$router.push({ path: '/invoice', })
  },
  mounted() {
    this.getStoreFn()
  },
  methods: {
    checkUrlFn() {
      // 获取当前URL的哈希部分  
      const hash = window.location.hash;  
      // 移除'#'字符  
      const url = hash.substring(1); 
      
      let postData = {
        url_path: url
      }
      api.checkLoginUrl(postData).then((res) => {
        if (res.status == 400) {
          this.$message({
            type: 'info',
            message: '暂无权限',
          })
          this.$router.push({
            path: `/home`
          });
        }
      })
    },
    checkNodeFn(menu_id) {
      let postData = {
        menu_id,
      }
      api.checkNode(postData).then((res) => {
        this.nodeLimtList = res.node_ids.split(',')
      })
    },
    NodeInclude(val) {
      return this.nodeLimtList.includes(val)
    },
    exportInvoiceToExcel() {
      window.location = api.exportInvoiceToExcel({
        ...this.form,
        start_time: this.fdate(this.form.time[0]) || '',
        end_time: this.fdate(this.form.time[1]) || '',
      })
    },

    dateValue(dateArr) {
      if (Array.isArray(dateArr)) {
        return this.fdate(dateArr[0]) + '-' + this.fdate(dateArr[1])
      } else {
        return ''
      }
    },

    check(key) {
      return this.checkList.includes(key)
    },

    viewClick(item) {
      console.log(item)
      this.$router.push({
        path: '/invoice/view',
        query: { id: item.id },
      })
    },

    search() {
      this.p = 1
      store.commit('setInvoiceData', JSON.parse(JSON.stringify(this.form)))
      this.getList()
    },

    getStoreFn() {
      this.form = Object.keys(store.state.invoiceData).length != 0 ? store.state.invoiceData : this.form
      this.getList()
    },

    getList() {
      this.checkUrlFn()
      this.checkNodeFn('61')
      const time = this.form.time || []
      const postData = {
        ...this.form,
        p: this.p,
        per_page: this.perPage,
        start_time: this.fdate(time[0]),
        end_time: this.fdate(time[1]),
        [this.form.atype]: this.form.key,//搜索
      }
      api.getInvoiceList(postData).then((res) => {
        this.itemList = res.itemList.map((item)=>{
          item.invoice_amount = thousands(Number(item.invoice_amount))
          item.applyArr.projectArr.contract_amount = thousands(Number(item.applyArr.projectArr.contract_amount))
          return item
        })
        this.total = +res.totalNum
      })
    },
    removeTag(tag) {
      !{
        type: () => {
          this.form['key'] = undefined
        },
      }[tag.val]?.()
      this.form[tag.val] = ''
      this.form.key = this.form.atype == '' ? '' : this.form.key 
      store.commit('setInvoiceData', JSON.parse(JSON.stringify(this.form)))
      this.getList()
      console.log(tag)
    },
    handleCurrentChange(p) {
      this.p = p
      store.commit('setInvoiceData', JSON.parse(JSON.stringify(this.form)))
      this.getList()
    },
  },
}
</script>

<style lang="scss" scoped>
.filterwrap {
  display: flex;
  justify-content: flex-end;
  align-items: center;
  padding: 0 0 20px 0;
  .filter {
    width: 85%;
  }
  .btnarea {
    box-sizing: border-box;
    width: 15%;
    padding: 0 20px;
    display: flex;
    justify-content: flex-end;
  }
}

.el-checkbox-group.filtergroup .el-checkbox {
  width: auto;
}

.apage {
  background: #f2f2f2;
  padding: 8px;
  text-align: right;
}

.el-select {
  margin-right: 20px;
}

.el-tag {
  margin-right: 20px;
  height: 36px;
  line-height: 36px;
  border: none;
}

.form {
  @extend %box;
  padding: 30px;
  margin-bottom: 20px;
}

.table {
  @extend %box;
  padding: 30px;
}

.linkwrap {
  font-size: 12px;
  &.normal {
    color: #606266;
    a {
      color: #606266;
      &:hover {
        &::after {
          height: 0.2px;
          background-color: #606266;
        }
      }
      >span {
        font-size: 12px;
        color: #606266;
      }
    }
  }
}
</style>
